<template>
  <div>
    <div v-if="!APPT_REQUESTED">
      <div class="col-12 text-center trainer-consultation-img">
        <img src="@/assets/img/personal_trainer.svg" v-if="trainingType == 'fitness'" style="height: 50vh;"/>
        <img src="@/assets/img/yoga.svg" v-if="trainingType == 'yoga'" style="height: 50vh;"/>
      </div>
    </div>
    <div v-if="APPT_REQUESTED" class="video-call-wrapper trainer-consult">
      <n-button icon v-if="TRAINER_JOINED" style="position: fixed;inset-inline-end: 2em;z-index: 9999;margin-top: 2em;" round type="danger" size="lg" @click.native="cancelAppointment" class="d-md-none">
        <i class="now-ui-icons ui-1_simple-remove"></i>
      </n-button>

      <vmaatu v-if="TRAINER_JOINED &&
        user.endpoint &&
        user.endpoint.videoConfEPType == 'VMAATU_RTC'
        " :query="simpleMeetingsQuery" ref="vmaatu"></vmaatu>
      <webex-teams v-if="TRAINER_JOINED &&
        user.endpoint &&
        user.endpoint.videoConfEPType == 'WEBEXTEAMS_GUEST'
        " :query="simpleMeetingsQuery" ref="webex-teams"></webex-teams>

      <div class="trainer-not-joined" v-if="!TRAINER_JOINED" style="
                    position: absolute;
                    height: 100vh;
                    z-index: 1030;
                    width: 100%;
                    background: #ffffff;
                    display: flex;
                    flex-direction: column;
                  ">

        <n-button round type="danger" size="lg" @click.native="cancelAppointment" class="d-md-block cancel-appt-request-button" v-if="APPT_REQUESTED">
          {{ $t("message.Cancel Request") }}
        </n-button>
        <img src="@/assets/img/bg2.svg" style="height: 45vh;" />
        <div class="col-12 text-center" style="margin-top: 15vh">
          <h6>{{ $t("message.Kindly wait until a Coordinator answers your request") }}</h6>
        </div>
      </div>
    </div>

    <n-button type="primary" round size="lg" @click.native="requestTrainerConsult()" style="
              top: auto;
              inset-inline-end: 10px;
              bottom: 4rem;
              left: 50%;
              transform: translateX(-50%);
              position: fixed;
              z-index: 999;
            ">
      <!-- <i class="fa fa-plus pr-1"></i> -->
      {{$t("message.Start consultation")}}
    </n-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      APPT_REQUESTED: false,
      TRAINER_JOINED: false,
      trainingType: "fitness",
    };
  },

  async mounted() {
    let that = this;

    if (this.$route.query.type) {
      this.trainingType = this.$route.query.type;
    }

    this.$root.onBackButton = () => {
      if (this.APPT_REQUESTED) {
        this.cancelAppointment();
      } else {
        this.$router.push("/patienthome");
      }
    };

    if (this.user) {
      // if (that.FCMpayload) {
      //   if (
      //     that.FCMpayload.type == "callNotification" &&
      //     that.FCMpayload.appointmentId
      //   ) {
      //     that.onCallPushNotification(that.FCMpayload);
      //     that.$store.state.FCMpayload = null;
      //   }
      // }

      setTimeout(() => {
        if (that.messages) {
          that.$store.state.message = that.selectedMessage = that.messages[0];
        }
      }, 2000);

      //Socket listeners
      socket.on("appointmentReviewed", async (data) => {
        this.appointmentId = data.appointmentId;

        //Get updated requested appointment's data
        this.appointment = await this.$store.dispatch(
          "getAppointment",
          this.appointmentId
        );

        this.$store.commit("setState", {
          stateName: "appointment",
          stateValue: this.appointment,
        });
        var msg = this.$t("message.Redirecting to appointment with");

        if (this.$refs["webex-teams"]) {
          this.endWebexCall();
        } else if (this.$refs.vmaatu) {
          this.$refs.vmaatu.destroy();
        }

        if (this.appointment.appointmentType == "Live") {
          if (data.specialityName) {
            msg =
              msg +
              this.$t("message.Doctor of speciality:") +
              "<b> " +
              data.specialityName +
              "</b>";
          } else {
            msg =
              msg +
              "<br><b>" +
              this.$t("message.Dr") +
              "." +
              this.appointment.provider.firstName +
              " " +
              this.appointment.provider.lastName +
              "</b>";
          }

          swal
            .fire({
              title: this.$t("message.Appointment Reviewed"),
              type: "success",
              html: msg,
              showCancelButton: false,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: this.$t("message.Proceed"),
              closeOnConfirm: true,
              timer: 10000,
            })
            .then(async () => {
              swal.close();

              if (this.settings.disclaimerText) {
                this.SHOW_DOCTOR_DISCLAIMER = true;
              } else {
                await this.sendSystemMessages();
                this.$router.push("telemed");
              }
            });
        } else {
          // $scope.getScheduledAppts($scope.filterDate);

          swal
            .fire({
              title: this.$t("message.Appointment Scheduled"),
              text: this.$t(
                "message.On {appointmentDate}, at {appointmentTime} with Dr{providerFirstName} {providerLastName}",
                {
                  appointmentDate: moment(
                    parseInt(this.appointment.scheduledTimestamp.start)
                  ).format("MMMM Do YYYY"),
                  appointmentTime: moment(
                    parseInt(this.appointment.scheduledTimestamp.start)
                  ).format("hh:mm a"),
                  providerFirstName: this.appointment.provider.firstName,
                  providerLastName: this.appointment.provider.lastName,
                }
              ),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "#DD6B55",
              closeOnConfirm: true,
              timer: 10000,
            })
            .then(() => {
              this.APPT_REQUESTED = false;
              this.TRAINER_JOINED = false;
              this.getScheduledAppointments();
            });
        }
      });

      socket.on("trainingRequestAttended", async (appointmentId) => {
        if (
          that.appointment &&
          that.appointment._id &&
          that.appointment._id == appointmentId
        ) {
          that.appointment = await that.$store.dispatch(
            "getAppointment",
            appointmentId
          );

          //Generate room url for Webex endpoints
          if (
            this.user.endpoint.videoConfEPType == "SPARK_EMBEDDED" ||
            this.user.endpoint.videoConfEPType == "WEBEXTEAMS_GUEST"
          ) {
            let webexTokens = await that.$store.dispatch(
              "getValidWebexGuestAccessToken"
            );

            if (webexTokens) {
              this.simpleMeetingsQuery = {
                api_key: this.settings.vMaatuSettings.apikey,
                room_name: this.instance + "_" + that.appointment._id + "_cc",
                user_name: this.user.username,
                tenant_name: this.user.tenant.name,
                access_token: webexTokens.accessToken,
                destination: that.appointment.webexTeams.roomId,
              };
            } else {
              localStorage.setItem("user", null);
              that.$router.push("signin");
            }
          }
          that.TRAINER_JOINED = true;

          setTimeout(() => {
            that.$refs.vmaatu.init();
          }, 1000);
        } else {
          that.TRAINER_JOINED = false;
          that.$refs.vmaatu.destroy();
        }
      });

      socket.on("trainingConsultationPaused", async (appointmentId) => {
        if (
          that.appointment &&
          that.appointment._id &&
          that.appointment._id == appointmentId
        ) {
          that.TRAINER_JOINED = false;
          that.$refs.vmaatu.destroy();
        }
      });

      socket.on("trainingConsultationCompleted", async () => {
        this.appointment = null;

        this.$store.commit("setState", {
          stateName: "appointment",
          stateValue: this.appointment,
        });

        this.APPT_REQUESTED = false;
        this.TRAINER_JOINED = false;

        if (this.$refs.vmaatu) this.$refs.vmaatu.destroy();

        swal.fire({
          title: this.$t("message.Appointment Update"),
          text: this.$t("message.Sorry! Your appointment was declined"),
          type: "warning",
          showCloseButton: true,
          timer: 4000,
        });

        this.getScheduledAppointments();
      });

      socket.on("newMessage", async (data) => {
        if (data.toUser == that.user._id) {
          this.getMessages();
          that.$refs["message-badge"].$el.style.display = "inline-block";
          that.unreadChatList.push(data.messageId);
        }
      });

      socket.on("appointmentListUpdate", () => {
        that.getScheduledAppointments();
      });

      socket.on("appointmentExit", async (data) => {
        this.getScheduledAppointments();
      });
      this.initSocket();
      window.initSocket = this.initSocket;

      //Nurse calling sockets
      socket.on("nurseCallingUpdate", (data) => {
        if (data.userId != this.user._id) {
          this.getRequestedServices();
        }
      });

      socket.on("newChatMessage", async (message) => {
        if (
          message.chatMessage.username !=
          this.incomingCallAppt.patient.patientId
        ) {
          if (
            message.chatMessage.status &&
            message.chatMessage.status == "cancelled"
          ) {
            this.callNotification = false;
            socket.emit("leaveRoom", {
              type: "appointment",
              id: this.incomingCallAppt._id,
              userId: this.user._id,
            });
          } else if (
            message.chatMessage.status &&
            message.chatMessage.status == "missed"
          ) {
            this.callNotification = false;
            socket.emit("leaveRoom", {
              type: "appointment",
              id: this.incomingCallAppt._id,
              userId: this.user._id,
            });
          }
        }
      });

      let vitalTopic =
        this.instance +
        "-" +
        this.user.tenant.name +
        "-" +
        this.$store.state.caregroup.name +
        "-vital-" +
        moment.tz.guess().replace("/", "-");
      console.log("Subscribed to topic - " + vitalTopic);

      let questionnaireTopic =
        this.instance +
        "-" +
        this.user.tenant.name +
        "-" +
        this.$store.state.caregroup.name +
        "-questionnaire-" +
        moment.tz.guess().replace("/", "-");
      console.log("Subscribed to topic - " + questionnaireTopic);

      let videoTopic =
        this.instance +
        "-" +
        this.user.tenant.name +
        "-" +
        this.$store.state.caregroup.name +
        "-video-" +
        moment.tz.guess().replace("/", "-");
      console.log("Subscribed to topic - " + videoTopic);





      /*       if (this.user && this.user.endpoint) {
        let response = await this.$store.dispatch(
          "getConfigurationByEndpointId",
          {
            endpointId: this.user.endpoint._id,
            type: "deviceProfile",
          }
        );
        if (response && response.value) {
          this.deviceProfile = response.value;
        }

        if (
          device.platform == "iOS" &&
          this.$store.state.connectedDevices &&
          cordova &&
          cordova.plugins &&
          cordova.plugins.CarenationDevicesPlugin
        ) {
          for (let device of this.deviceProfile) {
            if (
              device.identifier == "AppleHealthKit" &&
              device.manufacturer == "apple" &&
              device.model == "applewatch7" &&
              device.type == "vitals" &&
              device.vitals
            ) {
              clearInterval(window.syncAppleHealthKitInterval);
              window.syncAppleHealthKitInterval = setInterval(() => {
                syncAppleHealthKit(
                  device,
                  () => {
                    console.log("Apple healthkit synced");
                  },
                  (err) => {
                    console.log(err);
                  }
                );
              }, 300000);

              syncAppleHealthKit(
                device,
                () => {
                  console.log("Apple healthkit synced");
                },
                (err) => {
                  console.log(err);
                }
              );
              break;
            }
          }
        }
      } */
    } else {
      this.$router.push({ path: "/signin" });
    }
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
  },

  methods: {
    initSocket() {
      //Join room with patient ID
      socket.emit("joinRoom", {
        type: "user",
        id: this.user._id,
        deviceToken: localStorage.firebaseToken,
      });

      socket.emit("joinRoom", {
        type: "other",
        id: this.user.patientId,
      });

      //Join room with endpoint name
      socket.emit("joinRoom", {
        type: "endpoint",
        id: this.user.endpoint.name,
      });

      if (this.appointment && this.appointment._id) {
        //Join this appointment room
        socket.emit("joinRoom", {
          type: "appointment",
          id: this.appointment._id,
          userId: this.user._id,
        });
      }
    },
    async requestTrainerConsult(appt) {
      let that = this;

      let loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
      });
      if (this.user.caregroup) {
        try {
          if (appt) {
            this.appointment = appt;
          } else {
            this.appointment = {
              patient: {
                patientId: this.user.patientId,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                gender: this.user.gender,
                dob: this.user.dob,
                history: this.user.history,
              },
              questionnaire: "",
              attendant: {
                firstName: this.user.firstName,
                lastName: this.user.lastName,
              },
              appointmentStatus: [
                {
                  status: "Created",
                  timestamp: new Date().getTime(),
                },
              ],
              latestStatus: "Created",
              createdBy: "patient",
              appointmentType: "Live",
              endpoint: this.user.endpoint.name,
              consultationType: "teletraining",
              trainingType: this.trainingType, // fitness/ yoga
              preferredVideoCodec: "",
            };

            // this.appointment.careCoordinator = {
            //   caregroupId: this.user.caregroup._id || this.user.caregroup,
            // };

            this.appointment = await this.$store.dispatch(
              "requestTrainingConsultation",
              this.appointment
            );
          }

          socket.emit("trainingConsultationRequested", {
            type: this.trainingType,
          });

          // socket.emit(
          //   "appointmentRequested",
          //   this.appointment.careCoordinator.caregroupId
          // );
          socket.emit("trainingConsultationRequested", {
            type: this.trainingType,
          });

          this.$store.commit("setState", {
            stateName: "appointment",
            stateValue: this.appointment,
          });

          //Join this appointment room
          socket.emit("joinRoom", {
            type: "appointment",
            id: this.appointment._id,
            userId: this.user._id,
          });

          this.APPT_REQUESTED = true;

          if (
            !this.user.endpoint ||
            this.user.endpoint.videoConfEPType == "VMAATU_RTC"
          ) {
            this.simpleMeetingsQuery = {
              api_key: this.settings.vMaatuSettings.apikey,
              room_name: this.instance + "_" + this.appointment._id,
              user_name: this.user.username,
              tenant_name: this.user.tenant.name,
              controls: "true",
              video_encoding: this.appointment.preferredVideoCodec || "",
            };
          }

          socket.emit("appointmentCreated", {
            careCoordinatorId: this.appointment.careCoordinator.id,
            appointmentId: this.appointment._id,
          });
          loader.hide();
          this.$store.commit("setState", {
            stateName: "SHOW_TITLE_BAR",
            stateValue: false,
          });
          if (!appt) {
            swal.fire({
              title: this.$t("message.Appointment Requested"),
              text: this.$t(
                "message.Your appointment request has been sent to Care coordinator Please wait until his response"
              ),
              type: "success",
              timer: 3000,
              showCloseButton: true,
            });
          }
        } catch (e) {
          loader.hide();
          console.log(e);

          if (
            e.response &&
            e.response.data &&
            e.response.data.message == "No Care Coordinator online"
          ) {
            swal.fire({
              title: this.$t("message.Sorry!"),
              text: this.$t(
                "message.No Care Coordinators available Please try after some time In case of emergency call 1800 564 887"
              ),
              type: "warning",
              showCloseButton: true,
            });
          }
        }
      } else {
        loader.hide();
        swal.fire({
          title: this.$t("message.Sorry!"),
          text: this.$t(
            "message.Could not initiate the appointment Contact Administrator"
          ),
          type: "warning",
          showCloseButton: true,
        });
      }
    },

    async cancelAppointment() {
      console.log('cancelAppointment')
      let _that = this;
      swal
        .fire({
          title: this.$t("message.Cancel Appointment"),
          text: this.$t(
            "message.Are you sure that you want to cancel this request?"
          ),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: this.$t("message.Yes, Cancel"),
          cancelButtonText: this.$t("message.No"),
          closeOnConfirm: true,
        })
        .then(async (confirm) => {
          if (confirm.value) {
            await _that.$store.dispatch("updateStatus", {
              appointmentId: _that.appointment._id,
              status: "Cancelled",
            });

            if (this.$refs["webex-teams"]) {
              this.endWebexCall();
            }

            //Update care coordinator on appointment cancel
            socket.emit("trainingConsultationCancelled", {
              appointmentId: _that.appointment._id,
            });
            _that.appointment = null;

            _that.$store.commit("setState", {
              stateName: "appointment",
              stateValue: _that.appointment,
            });

            _that.APPT_REQUESTED = false;
            _that.TRAINER_JOINED = false;
            _that.getScheduledAppointments();
          } else {
            swal.close();
          }
        });
    },
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
  },
};
</script>

<style scoped>
.trainer-consultation-img {
  bottom: 10em;
  position: fixed;
}

.video-call-wrapper {
  width: 100%;
  position: fixed;
  top: 0px;
  bottom: 0px;
  inset-inline-end: 0px;
  height: 100vh;
  z-index: 1030;
  background-color: #f1f1f1;
}

.ios .video-call-wrapper {
  height: calc(100vh - 123px);
}

.cancel-appt-request-button {
  position: absolute;
  bottom: 4em;
  inset-inline-end: 50%;
  transform: translateX(50%);
  z-index: 1
}

[dir="rtl"] .cancel-appt-request-button {
  transform: translateX(-50%);
}
</style>
